import React from 'react';
import { Redirect } from '@ipc/ipc-core';

export const redirectToPath = to => <Redirect to={to} />;
